// extracted by mini-css-extract-plugin
module.exports = {"bold":"Text_bold__JUyF7","italic":"Text_italic__DXjZ5","strikethrough":"Text_strikethrough__lWlQn","underline":"Text_underline__WhB6n"};